export default __webpack_public_path__ + "static/media/mlh.dcbb855c.svg";